import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { formatMoneda, validaSoloNumero } from "../../util/varios";
import { Mensaje } from "../mensajes2";
import moment from "moment";
import CatalogoOrdenesPagosTerceroTipo from "../../catalogos/catalogoOrdenesPagosTerceroTipo";
import { Dimmer } from "../spinner";
import { SearchInput, Radio } from "../../ui/inputs/Input";
import { DangerButton, InfoButton } from "../../ui/buttons/Button";

export const ImpTxtIva = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const riforg = JSON.parse(localStorage.getItem("riforg"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
  const norden = true;

  const [usuario, setUsuario] = useState("");
  const [activate, setActivate] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);

  const [deshabilitado, setDeshabilitado] = useState(true);

  const [habiBot, setHabibot] = useState(false);
  const [cmbAnios, setCmbAnios] = useState();
  const [cmbMeses, setCmbMeses] = useState();
  const [activo, setActivo] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [datos] = useState();
  const [idOrden, setIdOrden] = useState(0);
  const btnImprimir = useRef();
  const radioArchivo = useRef();
  const radioVisualizar = useRef();
  const txtCodigo = useRef();
  const txtFecha = useRef();

  const cancelar = () => {
    txtCodigo.current.value = "";
    blanquear();
  };

  const salir = () => {
    blanquear();
    props.setShow(false);
  };

  const blanquear = () => {
    setActivate(false);
    setActivo(true);
    setDeshabilitado(true);
    setHabibot(false);
    radioArchivo.current.checked = false;
    radioVisualizar.current.checked = false;
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onDatos(datos);
    props.onHideCancela();
    blanquear();
  };
  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "codigo") {
          radioVisualizar.current.focus();
        } else if (event.target.id === "numfactura") {
          txtCodigo.current.focus();
        } else if (event.target.id === "numcontrol") {
          txtFecha.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    if (radioVisualizar.current.checked) {
      imprimirRetenciones();
    } else {
      generarTxt();
    }
  };

  const imprimirRetenciones = () => {
    var reporte = "";
    var sql = idOrden;
    if (norden) {
      reporte = "Adm_RetenIvaNumOrden";
    } else {
      reporte = "Adm_RetenIva";
    }
    var fechad = moment.utc(fechasistema).format("DD/MM/YYYY");
    var fechah = moment.utc(fechasistema).format("DD/MM/YYYY");
    var sql1 = "DESDE EL DIA " + fechad + " HASTA EL DIA " + fechah;
    window.open(
      op.reportes +
        "/administracionTesoreria?" +
        "reporte=" +
        reporte +
        "&CONDICION=" +
        sql +
        "&EFISCAL=" +
        idefiscal +
        "&TIT_RANGO=" +
        sql1.trim() +
        "&NOMELA=" +
        usuario,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };
  const generarTxt = () => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionesivatxt?idefi=${idefiscal}&&idorden=${idOrden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            var anio, mes, fechafac;
            var datos = "";
            var cRifOrg, cRifPro, cTexto, cNumFac, cNumCon, cCom, period;
            var nMonFac = 0.0,
              nBase = 0.0,
              nExen = 0.0,
              nIva = 0.0,
              nRet = 0.0;

            anio = new Date(fechasistema).getFullYear();
            mes = (new Date(fechasistema).getMonth() + 1)
              .toString()
              .padStart(2, 0);
            cRifOrg = riforg.trim().replaceAll("-", "").trim();
            for (let i = 0; i < response.data.length; i++) {
              fechafac = moment.utc(response.data[i].fecfactura)
                .format("YYYY-MM-DD")
                .toString();
              cRifPro = response.data[i].ben_rif
                .replace("-", "")
                .toUpperCase()
                .trim();
              cNumFac = response.data[i].numfactura.trim();
              cNumCon = response.data[i].numcontrol.trim();
              nMonFac = formatMoneda(
                response.data[i].mtofactura
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              nBase = formatMoneda(
                response.data[i].baseimpo
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              nRet = formatMoneda(
                response.data[i].mtoretenido
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              cCom = response.data[i].numcomprobante.trim();
              period = cCom.substring(0, 6);
              nExen = formatMoneda(
                response.data[i].exento
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              nIva = formatMoneda(
                response.data[i].iva
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              cTexto =
                cRifOrg +
                "\t" +
                period.trim() +
                "\t" +
                fechafac +
                "\t" +
                "C" +
                "\t" +
                "01" +
                "\t" +
                cRifPro +
                "\t" +
                cNumFac +
                "\t" +
                cNumCon +
                "\t" +
                nMonFac.toString().replace(/\./g, "").replace(",", ".") +
                "\t" +
                nBase.toString().replace(/\./g, "").replace(",", ".") +
                "\t" +
                nRet.toString().replace(/\./g, "").replace(",", ".") +
                "\t" +
                "0" +
                "\t" +
                cCom +
                "\t" +
                nExen.toString().replace(/\./g, "").replace(",", ".") +
                "\t" +
                nIva.toString().replace(/\./g, "").replace(",", ".") +
                "\t" +
                "0\n";
              datos = datos + cTexto;
            }

            const nombre = "RetencionIva.txt";
            const file = new Blob([datos.slice()], {
              type: "text/plain;charset=utf-8",
            });

            const fileURL = URL.createObjectURL(file);
            // const pdfWindow = window.open();
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download", nombre);
            document.body.appendChild(link);
            link.click();

            setMensaje({
              mostrar: true,
              titulo: "Exito",
              texto: "El archivo fue generado con exito",
              icono: "exito",
            });
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡No hay registros que cumplan con la condición!",
              icono: "error",
            });
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCancelaOrdenPago = () => {
    setMostrar5(false);
  };

  const handleAceptarOrdenPago = (
    numordenpago,
    idproveedor,
    montoordenpago,
    fecha,
    conceptoorden,
    idordenpago,
    tipo
  ) => {
    setMostrar5(false);
    setIdOrden(idordenpago);
    txtCodigo.current.value = norden ? numordenpago : idordenpago;
    radioArchivo.current.checked = true;
    radioVisualizar.current.checked = false;
    setHabibot(true);
  };

  const LlenarComboAnio = () => {
    var n = new Date().getFullYear();
    var a = [];
    for (var i = n; i >= 2015; i--) {
      a.push({ anio: i });
    }
    setCmbAnios(a);
    var meses = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    var m = [];
    for (var x = 0; x < 12; x++) {
      m.push({ nummes: x + 1, mes: meses[x] });
    }
    setCmbMeses(m);
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));

    if (obj != null) {
      setUsuario(obj.login);
    } else {
      setUsuario("");
    }
  }, []);

  const onChange = (e) => {
    if (e.target.name === "codigo") {
      blanquear();
    }
  };
  const handleOrdenPago = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setIdOrden(event.target.value);
      }
    }
  };
  const catalogoOrdenPago = (e) => {
    e.preventDefault();
    setMostrar5(true);
  };
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setActivo(false);
        LlenarComboAnio();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 text-light fw-bold m-0">
          Generar Archivo de Texto IVA
        </h3>
        <button className="btn btn-sm bg-light" onClick={salir}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-12 rounded border-azul p-2 m-0 d-flex flex-wrap">
          <div className="col-7 m-0 mb-2 p-0">
            <SearchInput label = 'N° Orden de Pago:'
              disabled
              name="codigo"
              onChange={onChange}
              onKeyUp={handleOrdenPago}
              onBlur={handleInputNumChange}
              id="inputDireccion"
            onClickButton={catalogoOrdenPago}
              ref={txtCodigo}
            />
          </div>
          <div className="col-6 p-0 m-0">
            <Radio label = 'Archivo txt'
              disabled={!habiBot}
              name="flexRadioDefault1"
              id="radioArchivo"
              ref={radioArchivo}
            />
          </div>
          <div className="col-6 p-0 m-0">
            <Radio label = 'Visualizar Reporte'
              disabled={!habiBot}
              name="flexRadioDefault1"
              id="radiVisualizar"
              ref={radioVisualizar}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <InfoButton icon = 'fa-print'
          ref={btnImprimir}
          disabled={!habiBot}
          onClick={onChangeValidar}
        >
          Imprimir
        </InfoButton>
        <DangerButton
          disabled={!habiBot}
          onClick={salir}
        >
         Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <CatalogoOrdenesPagosTerceroTipo
        show={mostrar5}
        tipo={0}
        onHideCancelar={handleCancelaOrdenPago}
        onHideAceptar={handleAceptarOrdenPago}
      />
    </Modal>
  );
};
